import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Hoang Uyen Da Lat Homestay';
const SITE_URL = 'https://hoanguyendalat.com';
const DEFAULT_IMAGE = `${SITE_URL}/favicon.ico`;
const DEFAULT_DESCRIPTION =
  'Cozy homestay in Da Lat, Vietnam surrounded by pine forests and mountains. Book your perfect mountain getaway today.';

const SEO = ({ title, description = DEFAULT_DESCRIPTION, path = '/', image = DEFAULT_IMAGE, noindex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {noindex && <meta name="robots" content="noindex" />}

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

const HomeSEO = () => (
  <>
    <SEO
      title="Your Mountain Getaway"
      description="Cozy homestay in Da Lat, Vietnam surrounded by pine forests and mountains. Book your perfect mountain getaway today."
      path="/"
    />
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'LodgingBusiness',
          name: SITE_NAME,
          description:
            'Cozy homestay in Da Lat, Vietnam surrounded by pine forests and mountains.',
          url: SITE_URL,
          image: DEFAULT_IMAGE,
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Da Lat',
            addressRegion: 'Lam Dong',
            addressCountry: 'VN',
          },
        })}
      </script>
    </Helmet>
  </>
);

export { HomeSEO };
export default SEO;
